import React from 'react';
export function CostComparison() {
  return <section className="py-20 bg-charcoal" data-id="element-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-serif font-bold flex items-center justify-center gap-3 text-white" data-id="element-53">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-16 rounded-xl border border-white/10 shadow-sm" data-id="element-54">
          <table className="w-full text-sm text-left min-w-[600px]" data-id="element-55">
            <thead className="bg-night-lighter text-white font-bold" data-id="element-56">
              <tr data-id="element-57">
                <th className="px-6 py-4" data-id="element-58">Sin MegaPack</th>
                <th className="px-6 py-4 bg-gold text-charcoal" data-id="element-59">Costo Real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/10 bg-night-light" data-id="element-60">
              {[['2-3 horas buscando qué hacer × 365 noches', 'Más de 700 horas de tu vida por año'], ['Improvisar en el peor momento de la noche', 'Decisiones desde el agotamiento que empeoran el problema'], ['Sin protocolo para pesadillas ni terrores', 'Noches que duran 2 horas innecesariamente'], ['Sin sistema para el miedo nocturno', 'El niño que no aprende a regularse solo'], ['Sin protocolo de transiciones', 'Siesta que arruina la noche, o derrumbe de las 5 PM'], ['Sin Mochila de Sueño en los viajes', 'Vacaciones que destruyen meses de progreso'], ['La próxima noche difícil sin saber qué hacer', 'El mismo ciclo, el próximo año']].map((row, i) => <tr key={i} className="hover:bg-white/5 transition-colors" data-id="element-61">
                  <td className="px-6 py-4 font-medium text-gray-200" data-id="element-62">
                    {row[0]}
                  </td>
                  <td className="px-6 py-4 text-red-500 font-bold" data-id="element-63">{row[1]}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto space-y-6" data-id="element-64">
          <h3 className="text-2xl font-bold text-white" data-id="element-65">
            La próxima noche puede ser diferente.
          </h3>
          <div className="bg-night-light p-8 rounded-xl border border-white/10 relative" data-id="element-66">
            <span className="absolute top-4 left-4 text-4xl text-gold/30 font-serif" data-id="element-67">
              "
            </span>
            <p className="text-xl font-serif italic text-gray-100 relative z-10" data-id="element-68">
              La próxima noche puede ser diferente.
            </p>
            <span className="absolute bottom-0 right-4 text-4xl text-gold/30 font-serif" data-id="element-69">
              "
            </span>
            <div className="mt-4 text-2xl" data-id="element-70">🌙</div>
          </div>
        </div>
      </div>
    </section>;
}